import classNames from "classnames";
import { graphql } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Trans, useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import * as React from "react"
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import SEO from "../../components/SEO";
import LiveIplWidgets from "../../containers/LiveIplWidgets";

import '../../styles/globals.scss'
import * as styles from './styles.module.scss'

const IndexPage = () => {
  const { t } = useTranslation("liveipl")
  const {language} = useI18next()

  return (
    <main>
      <SEO
        title={t("metaTitle")}
        description={t("description")}
        image={{
          src: '/src/images/ipl-og.jpg',
          width: 1200,
          height: 630,
        }}
        pathname="/live-ipl-betting"
      />

      <div className={styles.container}>
        <Header />
        <div className={styles.content}>
          <h1 className={classNames(styles.title, styles[language])}>{t("title")}</h1>
          <div className={styles.description}>{t("description")}</div>
          <div className={styles.freebet}>
            <div className={styles.firstTitle}>{t("freebet")}</div>
            <div className={styles.secondTitle}>{t("forNewClients")}</div>
            <div className={styles.amount}><span>500₹</span></div>
          </div>
          <a href="/rules" className={styles.rulesLink}>{t("rulesAndConditions")}</a>
          <a href={t("registerLink")} className={styles.button}>{t("register")}</a>
          <LiveIplWidgets />
          <div className={styles.text}>

            <h2>{t("texts.title1")}</h2>

            <Trans ns="liveipl" i18nKey={"texts.text1"} />

            <ul>
              <li>{t("texts.list1.item1")}</li>
              <li>{t("texts.list1.item2")}</li>
              <li>{t("texts.list1.item3")}</li>
              <li>{t("texts.list1.item4")}</li>
            </ul>

            <h3>{t("texts.subtitle1")}</h3>

            <Trans ns="liveipl" i18nKey={"texts.text2"} />

            <h3>{t("texts.subtitle2")}</h3>
            <Trans ns="liveipl" i18nKey={"texts.text3"} />

            <h3>{t("texts.subtitle3")}</h3>
            <Trans ns="liveipl" i18nKey={"texts.text4"} />

            <h3>{t("texts.subtitle4")}</h3>
            <Trans ns="liveipl" i18nKey={"texts.text5"} />

            <h3>{t("texts.subtitle5")}</h3>
            <Trans ns="liveipl" i18nKey={"texts.text6"} />
          </div>
        </div>
        <div className={styles.images}>
          <StaticImage className={styles.image} placeholder="blurred" quality={100} src="../../images/ipl-bg.png" alt="ipl-bg" />
          <StaticImage className={styles.imageMobile} placeholder="blurred" quality={100} src="../../images/ipl-bg-mobile.png" alt="ipl-bg-mobile" />
        </div>
      </div>
      <Footer />
    </main>
  )
}

export default IndexPage

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;